import "./App.css";
import { HashRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ForHomes from "./pages/ForHomes";
import SignUp from "./pages/SignUp";
import FAQ from "./pages/FAQ";
import Terms from "./pages/Terms";
import ForBusiness from "./pages/ForBusiness";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Customer from "./pages/Customer";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/for_homes" element={<ForHomes />}></Route>
        <Route path="/for_business" element={<ForBusiness />}></Route>
        <Route path="/sign-up" element={<SignUp />}></Route>
        <Route path="/pricing" element={<Pricing />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/faq" element={<FAQ />}></Route>
        <Route path="/customer" element={<Customer />}></Route>
        <Route path="/terms" element={<Terms />}></Route>
      </Routes>
    </HashRouter>
  );
}

export default App;
